<template>
  <v-card :style="backOpacity">
    <v-card-title>画像欄</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <!--
          <v-col cols="12">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          -->
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-text-field
              label="参照フォームID"
              v-model="returnData.init"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="縦幅(px)"
              v-model="returnData.height"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="横幅(px)"
              v-model="returnData.width"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    label: String,
    init: String,
    type: Number,
    cols: String,
    position: Number,
    width: Number,
    height: Number,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        cols: this.cols,
        position: this.position,
        width: this.width,
        height: this.height,
      },
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
      },
      backOpacity: "opacity: 1",
    };
  },
  mounted() {},
  methods: {
    submit() {
      if (this.returnData.init == "" || isNaN(this.returnData.init)) return;
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
